<template>
	<div class="scrollable only-y">
	<div class="page-header card-base card-shadow--medium" v-loading="loadingDetail" element-loading-background="rgba(0, 0, 0, 0.8)">
		<h2 class="no-m white-text"><i class="mdi mdi-bank widget-icon accent-text fs-30"></i> Finance Config</h2>
	</div>
	<el-card>
		<el-tabs type="border-card" v-model="activeTab" v-loading="loadingPage">
			<el-tab-pane label="Topup Credit" name="config">
				<el-form status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm">
					<h4>Config Fee and Tax</h4>
					<el-form-item label="PP 23" prop="service_fee">
						<el-input disabled :value="data.service_fee_currency" style="width: 220px" class="mr-5"></el-input>
						<el-input v-model="data.service_fee" @keypress.native="numberOnly" type="text" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item label="PPN" prop="tax">
						<el-input disabled :value="data.ppn_currency" style="width: 220px" class="mr-5"></el-input>
						<el-input v-model="data.ppn" @keypress.native="numberOnly" type="text" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item label="PPH 23" prop="tax">
						<el-input disabled :value="data.pph_currency" style="width: 220px" class="mr-5"></el-input>
						<el-input v-model="data.pph" @keypress.native="numberOnly" type="text" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="addConfig" type="primary" :loading="loadingAddConfig">Save</el-button>
					</el-form-item>
				</el-form>
			</el-tab-pane>
		</el-tabs>
    </el-card>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import config from '@/config'
import api from '@/networkClient'
import Template from './consumen/Template.vue'

export default {
  components: { Template },
	name: 'Config',
    data() {
        return {
			activeTab: "config",
			optionCurrency: [
				{
					name: 'Percentage',
					value: 'percentage'
				},
				{
					name: 'Currency',
					value: 'currency'
				}
			],
			data: {
				service_fee_currency: 'Percentage',
				service_fee: '',
				ppn_currency: 'Percentage',
				ppn: '',
				pph_currency: 'Percentage',
				pph: ''
			},
			loadingAddConfig: false,
			loadingDetail: false,
			loadingPage: false
        }
    },
    methods: {
		numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Comma
                (e.keyCode === 44) ||
                // Allow: Period
                (e.keyCode === 46) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
		async addConfig() {
			var data = this.data;
			if (data.ppn > 100) {
				this.$message.error({
					showClose: true,
					duration: 5000,
					message: "PPN cannot more than 100 percent"
				});
				return
			} else if (data.pph > 100) {
				this.$message.error({
					showClose: true,
					duration: 5000,
					message: "PPH cannot more than 100 percent"
				});
				return
			} else {
				this.loadingAddConfig = true;
				await api({
					method: "patch",
					data: {
						service_fee_type: data.service_fee_currency,
						service_fee_amount: +data.service_fee,
						ppn: +data.ppn,
						pph: +data.pph
					},
					url: config.baseApi + 'master-config-topup-credit',
				}).then(res => {
					var status =
						res &&
						res.data &&
						res.data.ec
							? res.data.ec
							: null;
					if (status === 200) {
						this.$swal(this.$t('success'), this.$t('success'), "success")
					} else {
						this.$swal(this.$t('error'), 'Failed to update data!', "error")
					}
					this.loadingAddConfig = false;
				}).catch(err => {
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					return err
				})
			}
		},
		async getConfig() {
			this.loadingPage=true;
			await api({
                method: "get",
                url: config.baseApi + 'master-config-topup-credit',
            }).then(res => {
				var data =
					res &&
					res.data &&
					res.data.data
						? res.data.data
						: {}

				this.data = {
					service_fee_currency: data.service_fee_type,
					service_fee: data.service_fee_amount,
					ppn_currency: 'Percentage',
					ppn: data.ppn,
					pph_currency: 'Percentage',
					pph: data.pph
				};
			}).catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error");
                return err
            })
			this.loadingPage=false;
		}
    },
   	async mounted(){
		await this.getConfig();
    }
}
</script>
<style scoped>
.swal2-container {
	z-index: 10000 !important;
}

.img-center {
    display: block;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 50%;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
table th {
  background: #79DFFF;
  color: black;
  font-weight: bold;
  /* font-size: 18px; */
}
/* .css-serial { */
  /* counter-reset: serial-number;  Atur penomoran ke 0 */
/* } */
/* .css-serial td:first-child:before { */
  /* counter-increment: serial-number;  Kenaikan penomoran */
  /* content: counter(serial-number);  Tampilan counter */
/* } */
</style>
<style lang="scss">
@import '../assets/scss/_variables';

.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}

.row {
	margin-top: 30px;
}

.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			float: right;
			margin-bottom: 30px;

			.logo {
				float: right;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}
}
</style>
